import apiClient from "../ApiClient";

const notificationService = () => {
  const { request } = apiClient();

  const fetchUserNotifications = async (userId, page = 0, size = 10) => {
    try {
      const url = `/notifications/user?userId=${userId}&page=${page}&size=${size}`;      
      return await request("GET", url);
    } catch (error) {
      console.error("Failed to fetch notifications", error);
      throw error;
    }
  };
  const fetchNotificationById = async (id, userId) => {
    try {
      const url = `/notifications/details?id=${id}&userId=${userId}`;
      console.log(url);
      return await request("GET", url);
    } catch (error) {
      console.error("Failed to fetch notifications", error);
      throw error;
    }
  };

  const markAsRead = async (userId, notificationIds) => {
    try {
      const payload = {
        userId,
        notificationIds
      };
      console.log(payload);
      return await request("POST", "/notifications/mark-as-read", payload);
    } catch (error) {
      console.error("Failed to mark notifications as read", error);
      throw error;
    }
  };

  return {
    fetchUserNotifications,
    markAsRead,
    fetchNotificationById
  };
};

export default notificationService;
